import { styled } from '@mui/system';
import hammer from '../../../assets/icons/hammer.svg';
import forgeIt from '../../../assets/icons/forge.svg';
import umk from '../../../assets/icons/umk.svg';
import { useTranslation } from 'react-i18next';
import React from 'react';


const FooterContainer = styled('footer')({
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    gap: '90px',
    alignItems: 'center',
    flexDirection: 'row',
    padding: '40px 48px',
    '@media (max-width: 1024px)': {
        flexDirection: 'column',
        gap: '32px',
        padding: '32px 16px',
    }
});

const FooterTextContainer = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
    '@media (max-width: 1024px)': {
        gap: '16px',
    }
});

const NavContainer = styled('nav')({
    display: 'flex',
    alignItems: 'flex-start',
    gap: '36px',
    '@media (max-width: 1024px)': {
        flexDirection: 'column',
        gap: '16px',
    }
});

// const NavLink = styled('a')({
//     textDecoration: 'none',
//     color: '#F1F7F7',
//     fontSize: '14px',
//     fontWeight: '400',
//     lineHeight: '26px',
//     '@media (max-width: 1024px)': {
//         fontSize: '12px',
//         lineHeight: '20px',
//     }
// });

const NavLanguageContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    color: '#F1F7F7',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '26px',
    '@media (max-width: 1024px)': {
        fontSize: '12px',
        lineHeight: '20px',
    }
});

const NavLanguage = styled('select')({
    color: '#00E378',
    backgroundColor: '#021a1a',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '26px',
    border: 'none',
    '@media (max-width: 1024px)': {
        fontSize: '12px',
        lineHeight: '20px',
    }
});

const AstrolabeTitle = styled('h2')({
    fontSize: '19px',
    fontWeight: '700',
    lineHeight: '26px',
    color: '#00E378',
    '@media (max-width: 1024px)': {
        fontSize: '16px',
        lineHeight: '22px',
    }
});

const FooterText = styled('p')({
    color: '#00644B',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '26px',
    '@media (max-width: 1024px)': {
        fontSize: '12px',
        lineHeight: '20px',
    }
});

const FooterIconContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
    gap: '48px',
    '@media (max-width: 1024px)': {
        gap: '32px',
    }
});

const ForgeItLogoContainer = styled('div')({
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    gap: '10px',
    '@media (max-width: 1024px)': {
        gap: '8px',
    }
});

const HammerLogo = styled('img')({
    width: '35px',
    height: '26px',
    '@media (max-width: 1024px)': {
        width: '28px',
        height: '21px',
    }
});

const ForgeItLogo = styled('img')({
    width: '58px',
    height: '16px',
    '@media (max-width: 1024px)': {
        width: '46px',
        height: '13px',
    }
});

const UmkLogo = styled('img')({
    width: '53px',
    height: '24px',
    '@media (max-width: 1024px)': {
        width: '42px',
        height: '19px',
    }
});



export const Footer = () => {
    const { t, i18n } = useTranslation();

    const changeLanguage = (event: React.ChangeEvent<HTMLSelectElement>) => {
        i18n.changeLanguage(event.target.value);
    };

    // Utilisez useEffect pour s'assurer que le select est à jour après le chargement
    React.useEffect(() => {
        const langSelect = document.querySelector('select[name="language-select"]');
        if (langSelect) {
            (langSelect as HTMLSelectElement).value = i18n.language.substring(0, 2);
        }
    }, [i18n.language]);

    return (
        <FooterContainer>
            <FooterTextContainer>
                <NavContainer>
                    <AstrolabeTitle>
                        Astrolabe
                    </AstrolabeTitle>
                    {/* <NavLink href="#">
                        {t('footer.termsOfUse')}
                    </NavLink>
                    <NavLink href="#">
                        {t('footer.privacyStatement')}
                    </NavLink>
                    <NavLink href="#">
                        {t('footer.cookiePreferences')}
                    </NavLink> */}
                    <NavLanguageContainer>
                        {t('footer.language')} :
                        <NavLanguage
                            name="language-select"
                            value={i18n.language.substring(0, 2)}
                            onChange={changeLanguage}
                        >
                            <option value="en">English</option>
                            <option value="fr">Français</option>
                        </NavLanguage>
                    </NavLanguageContainer>
                </NavContainer>
                <FooterText>
                    {t('footer.description')}
                </FooterText>
            </FooterTextContainer>
            <FooterIconContainer>
                <ForgeItLogoContainer>
                    <HammerLogo src={hammer} alt="hammer" />
                    <ForgeItLogo src={forgeIt} alt="forgeIt" />
                </ForgeItLogoContainer>
                <UmkLogo src={umk} alt="umk" />
            </FooterIconContainer>
        </FooterContainer>
    )
}
